import React, { useState } from "react";
import { StaffActionDialog } from "./StaffActionDialog";
import { WarehouseTaskDetailDialog } from "../../pages/firm/warehouse/WarehouseTaskDetailDialog";
import { useWarehouseTaskStore } from "../../store/warehouseTask";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

interface Staff {
  userId: number;
  name: string;
  totalTaskScore?: number;
  pickingDoneCount?: number;
  packagingDoneCount?: number;
  pickingOngoingCount?: number;
  packagingOngoingCount?: number;
  assignedPickingCount?: number;   // 🆕 (backend ekleyeceğiz)
  assignedPackagingCount?: number; // 🆕
}

interface Props {
  performanceData: Staff[];
  logsData: any;
  loading: boolean;
}

export const StaffPerformanceList = ({
  performanceData,
  logsData,
  loading,
}: Props) => {
  const taskStore = useWarehouseTaskStore();

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogUser, setDialogUser] = useState<Staff | null>(null);
  const [dialogAction, setDialogAction] = useState<string | null>(null);
  const [selectedTask, setSelectedTask] = useState<any | null>(null);

  const handleOpenTaskDetail = async (taskId: number) => {
    const fullTask = await taskStore.getSingleTask(taskId, true);
    setSelectedTask(fullTask);
  };

  const nameBodyTemplate = (staff: Staff) => (
    <div className="flex items-center gap-3">
      <div className="w-8 h-8 rounded-lg bg-primary/10 text-primary flex items-center justify-center font-bold text-[10px]">
        {staff.name
          ?.split(" ")
          .map((n) => n[0])
          .join("")
          .toUpperCase()
          .substring(0, 2)}
      </div>
      <span className="font-semibold text-sm text-text">{staff.name}</span>
    </div>
  );

  const scoreBodyTemplate = (staff: Staff) => (
    <span className="font-black text-amber-600">
      {(staff.totalTaskScore || 0).toFixed(1)}
    </span>
  );

  const actionBodyTemplate = (
    staff: Staff,
    type: "PICKING" | "PACKAGING"
  ) => {
    const done =
      type === "PICKING"
        ? staff.pickingDoneCount
        : staff.packagingDoneCount;

    const ongoing =
      type === "PICKING"
        ? staff.pickingOngoingCount
        : staff.packagingOngoingCount;

    const assigned =
      type === "PICKING"
        ? staff.assignedPickingCount
        : staff.assignedPackagingCount;

    return (
      <button
        onClick={() => {
          setDialogUser(staff);
          setDialogAction(type);
          setDialogOpen(true);
        }}
        className="flex items-center gap-2 px-3 py-1.5 rounded-lg hover:bg-black/5 dark:hover:bg-white/5 transition-all text-xs border border-transparent hover:border-borderColor/30"
      >
        <span className="font-bold text-green-600">{done || 0}</span>

        <span className="opacity-30">/</span>

        <span className="font-bold text-blue-600">{ongoing || 0}</span>

        {/* 🆕 atanmış ama başlamamış */}
        <span className="opacity-30">/</span>

        <span className="font-bold text-gray-500">{assigned || 0}</span>
      </button>
    );
  };

  return (
    <div className="card p-0 rounded-2xl overflow-hidden border border-borderColor/40">
      <DataTable
        value={performanceData}
        loading={loading}
        className="p-datatable-sm p-datatable-striped"
        emptyMessage="Veri bulunamadı."
      >
        <Column
          field="name"
          header="Personel"
          body={nameBodyTemplate}
        />

        <Column
          field="totalTaskScore"
          header="Skor"
          body={scoreBodyTemplate}
          align="center" style={{  justifyItems: 'center'}}
        />

        <Column
          header="Toplama (Bitti / Devam / Atanan)"
          body={(data) => actionBodyTemplate(data, "PICKING")}
          align="center" style={{  justifyItems: 'center'}}
        />

        <Column
          header="Paketleme (Bitti / Devam / Atanan)"
          body={(data) => actionBodyTemplate(data, "PACKAGING")}
          align="center" style={{  justifyItems: 'center'}}
        />
      </DataTable>

      <StaffActionDialog
        visible={dialogOpen}
        onHide={() => setDialogOpen(false)}
        user={dialogUser}
        actionType={dialogAction}
        logs={logsData}
        onOpenTaskDetail={handleOpenTaskDetail}
      />

      <WarehouseTaskDetailDialog
        isOpen={!!selectedTask}
        task={selectedTask}
        onClose={() => setSelectedTask(null)}
      />
    </div>
  );
};